module.exports = __webpack_public_path__ + "img/kim-robertsen-p.75f65179.webp";